import React, { Component } from 'react'
import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";


export class LoginPage extends Component {
    render() {
        return (
            <div>
                <Navbar></Navbar>
                <div>
                    Login 
                </div>
                <Footer></Footer>
            </div>
        )
    }
}

export default LoginPage
